export default __webpack_public_path__ + "static/media/d51.3ea93282.png";